import { useEffect } from 'react';

type Options = {
  onEscape?: () => void;
  onEnter?: () => void;
  enterDisabled?: boolean;
};

export function useModalKeyboard( { onEscape, onEnter, enterDisabled }: Options ) {
  useEffect( () => {
    const handler = ( e: KeyboardEvent ) => {
      if ( e.key === 'Escape' && onEscape ) {
        e.preventDefault();
        onEscape();
      }
      if ( e.key === 'Enter' && onEnter && !enterDisabled ) {
        const target = e.target as HTMLElement;
        if ( target.tagName === 'TEXTAREA' ) return;
        e.preventDefault();
        onEnter();
      }
    };
    document.addEventListener( 'keydown', handler );
    return () => document.removeEventListener( 'keydown', handler );
  }, [ onEscape, onEnter, enterDisabled ] );
}
